module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_17_m2.58d2e97fb0f5473a2e2979390656fba9.png";